<template>
    <div class="fot-hd_mobile">
        <div style="border-bottom: 3rem solid #d7d7d7">
            <div class="footer">
                <div class="fot_pic">
                    <div class="douyin_box" @click="showDouyinimg">
                        <a href="javascript:"> <img class="fotImg" src="../../../static/images/douyin1.png" alt="" /> </a>
                        <div>官方抖音</div>
                        <img id="douyin" :src="msgs.douyinLink" alt="" v-show="showDouyin"/>
                    </div>
                    <div class="weibo_box" @click="showWeiboimg">
                        <a href="javascript:"> <img class="fotImg" src="../../../static/images/web1.png" alt="" /> </a>
                        <div>官方微博</div>
                        <img id="weibo" :src="msgs.weiboLink" alt="" v-show="showWeibo" />
                    </div>
                    <div class="weixin_box" @click="showWeixinimg">
                        <a href="javascript:"> <img class="fotImg" src="../../../static/images/weixin1.png" alt="" /> </a>
                        <div>官方微信</div>
                        <img id="weixin" :src="msgs.wechatLink" alt="" v-show="showWeixin"/>
                    </div>
                </div>
                <div>
                    <div class="lianxi">
                        <p>地址：{{ msgs.address }}</p>
                        <p>邮箱：{{ msgs.email }}</p>
                        <p>集团电话：{{ msgs.tel }}</p>
                        <p>合作热线：{{ msgs.hotLine }}</p>
                    </div>
                </div>
                <div class="youqing_box">
                    <div class="divflex2">
                        <div class="divflex2_p1">友情链接</div>
                        <div class="friendlylink">friendly link</div>
                    </div>
                    <div>
                        <div class="divflex3s">
                            <el-select style="width: 95%; margin-top: 50rem;" value="" placeholder="政府网站链接区">
                                <a target="_blank" :href="item.address" v-for="(item, index) in lianjie2" :key="index">
                                    <el-option style="font-size: 75rem; height: 200rem; line-height: 200rem;" value="value1" :label="item.name"> </el-option>
                                </a>
                            </el-select>
                        </div>
                    </div>
                    <div>
                        <div class="divflex4s">
                            <el-select
                                style="width: 95%;
                                margin-top: 50rem; font-size: 75rem;"
                                value="" placeholder="行业网站链接区">
                                <a target="_blank" :href="item.address" v-for="(item, index) in lianjie" :key="index">
                                    <el-option style="font-size: 75rem; height: 200rem; line-height: 200rem;" value="value2" :label="item.name"
                                        > </el-option>
                                </a>
                            </el-select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom">
            <div class="mb_new_sp">
                <img src="../../../static/images/fot_zmlogo.png"/>
                <span>中明建投建设集团有限责任公司</span>
            </div>
            <div class="bottomflex">
                <div class="mb_new_sp">
                    <img src="@/assets/jinghui.png"/>
                    <!-- 网站备案： -->
                    <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=61019102000389" target="_blank"
                        >陕公网备61019102000389号</a>
                </div>
                <div class="mb_new_sp">
                    <!-- 网站备案： -->
                    <a :href="msgs.internetRecordLink" target="_blank">{{ msgs.internetRecord }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getfriendship } from '@/api/api';
import { getmsg } from '@/api/api';

export default {
    data() {
        return {
            // golaburl: 'http://39.101.74.19:8717/base-admin',
            value1: '政府网站链接区',
            value2: '行业网站链接区',
            // label1: '政府网站链接区',
            // label2: '行业网站链接区',
            lianjie: [],
            lianjie2: [],
            status: 2,
            status2: 1,
            msgs: [],
            value: '',
            showDouyin: false,
            showWeibo: false,
            showWeixin: false,
        };
    },

    mounted() {
        this.getfriendship();
        this.getfriendshiptwo();
        this.getmassage();
    },

    methods: {
        // 展示抖音二维码
        showDouyinimg() {
            if (this.showDouyin === false) {
                this.showDouyin = true
            } else {
                this.showDouyin = false
            }
            this.showWeibo = false;
            this.showWeixin = false;
        },
        // 展示微博二维码
        showWeiboimg() {
            if (this.showWeibo === false) {
                this.showWeibo = true
            } else {
                this.showWeibo = false
            }
            this.showDouyin = false;
            this.showWeixin = false;
        },
        // 展示微信二维码
        showWeixinimg() {
            if (this.showWeixin === false) {
                this.showWeixin = true
            } else {
                this.showWeixin = false
            }
            this.showDouyin = false;
            this.showWeibo = false;
        },
        // goproduct(loc) {
        //     let toElement = document.getElementById(loc);
        //     toElement.scrollIntoView();
        //     this.$router.push('/product');
        //     // this.$router.go(0);
        // },
        // 锚点跳转
        // goproduct(path, id) {
        //     var path = path;
        //     var Id = id;
        //     localStorage.setItem('toId', Id);
        //     this.$router.push(path);
        // },
        // 友情链接
        async getfriendship() {
            const res = await getfriendship(this.status);
            if (res.code == 200) {
                this.lianjie = res.data;
            }
        },
        async getfriendshiptwo() {
            const res = await getfriendship(this.status2);
            if (res.code == 200) {
                this.lianjie2 = res.data;
            }
        },
        async getmassage() {
            const res = await getmsg();
            if (res.code == 200) {
                this.msgs = res.data[0];
            }
        },
    },
};
</script>
<style scoped lang="scss">
.fot-hd_mobile {
    width: 100%;
    background-image: url(../../../static/images/footer_bgimg.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .footer {
        position: relative;
        .fot_pic {
            padding-left: 100rem;
            .douyin_box,
            .weibo_box,
            .weixin_box {
                font: normal 60rem 'Source Han Sans CN-Regul';
                display: inline-block;
                margin: 102.5rem 70rem 50rem 0;
                text-align: center;
                color: #656565;

                // 清除点击时出现的蓝色小方块
                -webkit-tap-highlight-color: rgba(255,0,0,0);
                -webkit-appearance:none;

                .fotImg {
                    width: 187.5rem;
                    height: 187.5rem;
                }

                #douyin,
                #weibo,
                #weixin {
                    width: 600rem; height: 600rem;
                    position: absolute;
                    top: 370rem;
                    left: 235rem;
                }
            }
        }

        .lianxi {
            width: 100%;
            p {
                width: 100%;
                margin-left: 100rem;
                color: #656565;
                font: normal 60rem 'Source Han Sans CN-Regul';
            }
        }

        .youqing_box {
            margin: 150rem 0 70rem 100rem;
            // 清除点击时出现的蓝色小方块
            -webkit-tap-highlight-color: rgba(255,0,0,0);
            -webkit-appearance:none;
            .divflex2 {
                border-left: 5rem solid #0E6EB8;
                padding-left: 10rem;
                .divflex2_p1 {
                    font: bold 60rem 'Source Han Sans CN-Bold';
                }

                .friendlylink {
                    font: normal 33rem 'Source Han Sans CN-Bold';
                    color: #1C76CE;
                }
            }
        }
    }

    .bottom {
        // 清除点击时出现的蓝色小方块
        -webkit-tap-highlight-color: rgba(255,0,0,0);
        -webkit-appearance:none;
        margin: 60rem 0 0 100rem;
        font: normal 60rem 'Source Han Sans CN-Bold';
        position: relative;

        span {
            margin-left: 100rem;
            color: #9A9A9A;
        }
        img {
            width: 75rem;
            position: absolute;
            top: 5rem;
        }

        .bottomflex {
            padding-bottom: 60rem;
            display: flex;
            justify-content: flex-start;
            .mb_new_sp {
                margin-top: 30rem;
                position: relative;

                a {
                    margin-left: 100rem;
                    color: #9A9A9A;
                }
                img {
                    width: 75rem;
                    position: absolute;
                    top: 5rem;
                }
            }
        }
    }
}
</style>

<style lang="scss">
.fot-hd_mobile {
    .el-input__inner {
        height: 180rem!important;
        font-size: 60rem!important;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/mobile/footer_mobile.vue